module.exports = __webpack_public_path__ + "static/logo_3x2-7c587a459c81f7d13631ead786fd055b.png";